export default {
  signin: {
    title: "Авторизация",
    userForm: {
      username: {
        placeholder: "Пользователь"
      },
      password: {
        placeholder: "Пароль"
      },
      language: {
        placeholder: "Язык"
      },
      connection: {
        placeholder: "Подключение"
      },
      server: {
        placeholder: "Сервер"
      },
      section: {
        placeholder: "Приложение"
      },
      base: {
        placeholder: "База"
      },
      signin: "Вход"
    },
    userRules: {
      username: {
        required: "Необходимо ввести имя пользователя",
        min: "Имя пользователя должно быть не менее 3 символов",
        max: "Имя пользователя должно быть не более 24 символов"
      },
      password: {
        required: "Необходимо ввести пароль",
        min: "Длина пароля должна быть не менее 3 символов",
        max: "Длина пароля должна быть не более 24 символов"
      },
      language: {
        required: "Необходимо выбрать язык"
      },
      connection: {
        required: "Необходимо выбрать подключение"
      },
      server: {
        required: "Необходимо выбрать сервер"
      },
      section: {
        required: "Необходимо выбрать приложение"
      },
      base: {
        required: "Необходимо выбрать базу"
      }
    },
    version: {
      current: "Версия:",
      serverMin: "Cервер (мин.):",
      apiMin: "API (мин.):"
    }
  }
};
